export default __webpack_public_path__ + "static/media/total-purchase.52a08279.svg";